import { render, staticRenderFns } from "./create-integration-dialog-facebook.vue?vue&type=template&id=14640a48&scoped=true&"
import script from "./create-integration-dialog-facebook.vue?vue&type=script&lang=ts&"
export * from "./create-integration-dialog-facebook.vue?vue&type=script&lang=ts&"
import style0 from "./create-integration-dialog-facebook.vue?vue&type=style&index=0&id=14640a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14640a48",
  null
  
)

export default component.exports